const ALL = '-2';
const NONE = '-1';

const numOrNull = (s) => {
  if (s == null) return null;
  const v = String(s);
  if (v === '' || v === '0' || v === NONE) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const uniqInts = (arr) =>
  Array.from(new Set((Array.isArray(arr) ? arr : []).map(Number))).filter(Number.isFinite);

const normalizeScenarioSelection = (ids = []) => {
  const arr = (Array.isArray(ids) ? ids : []).map(String);

  if (arr.includes(ALL)) return [Number(ALL)];
  if (arr.length === 0 || arr.includes(NONE)) return [];
  return uniqInts(arr);
};

export const serializeForApi = (a) => ({
  business_case_id: numOrNull(a.businessCaseId),
  entity_id: numOrNull(a.entityId),
  scenario_id: normalizeScenarioSelection(a.scenarioId),
  account_id: numOrNull(a.accountId),
  target_entity_id: numOrNull(a.targetEntityId),
  target_scenario_id: normalizeScenarioSelection(a.targetScenarioId),
  target_account_id: numOrNull(a.targetAccountId),
});